export default {
	es: {
		enlaces : {
			login : '/login',
			restablecer_login : '/restablecer-tutor',
			validaciones : '/validaciones',
			evaluaciones : "/evaluaciones",
			tutorados : "/tutorados",
			ficha : "/ficha",
			fichaaprobacion : "/aprobacion",
			encuesta : '/encuesta',
			encuestas : '/encuestas',
			acceso : '/acceso',
			miperfil :'/mi-perfil',
			aprobacionesdirector: '/aprobaciones',
			aprobacionesdirector: '/aprobaciones',
			ofertaspracticas : '/ofertas-practicas',
			ofertasPracticasTutor:'/ofertas',
			utilidades : "/utilidades",
			"1" : "pendientes",
			"2" : "validadas",
			"3" : "rechazadas",
		},
		encabezado : {
			home : 'Bienvenid@',
			politica_privacidad : "Política de privacidad",
			politica_cookies : "Política de cookies",
			login : "Inicio de sesión",
			documentacion : 'Documentación',
			restablecer_login : 'Restablecer Contraseña',
			encuesta : 'Encuesta',
			acceso : 'Acceso',
			ofertascf : "Ofertas CF",
			ofertasPracticasTutor:"Ofertas Prácticas"
		},
	},
	en: {
		enlaces : {
		}
	}
}



// WEBPACK FOOTER //
// ./src/translations/index.js